import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import './assets/fonts/inter.css'
import './assets/fonts/barlow.css'
import './styles/index.css'
import Router from './Router.jsx'
import ErrorBoundary from './components/ErrorBoundary'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <ErrorBoundary>
        <Router />
      </ErrorBoundary>
    </HelmetProvider>
  </StrictMode>,
)
